export enum RccapRootCauseOther {    
    Medicaid = 0,
    InadequateDonorCoverage = 1,
    CompatibleLdAvailable = 2
}